import { UPDATE_STATUS_SUCCESS, UPDATE_STATUS_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case UPDATE_STATUS_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case UPDATE_STATUS_FAILURE:
			return {
				...state,
				isLoading: false,
				errorData: action.payload,
				error: true,
			};
		default:
			return { ...state };
	}
};
